module.exports = __webpack_public_path__ + "img/assignment-ind.911df473.svg";